import { render, staticRenderFns } from "./ad-neg-target.vue?vue&type=template&id=2bc5565f&scoped=true&"
import script from "./ad-neg-target.vue?vue&type=script&lang=js&"
export * from "./ad-neg-target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc5565f",
  null
  
)

export default component.exports